import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { PlatformApiClient } from './platform-api-client.js';
const PlatformApiContext = createContext(null);
export function PlatformApiProvider(props) {
    const client = useMemo(() => new PlatformApiClient({
        ...(props.baseUrl === undefined ? {} : { baseUrl: props.baseUrl }),
        ...(props.authentication === undefined ? {} : { authentication: props.authentication }),
    }), [props.authentication, props.baseUrl]);
    return _jsx(PlatformApiContext, { value: client, children: props.children });
}
export function usePlatformApi() {
    const client = useContext(PlatformApiContext);
    if (client === null)
        throw new Error('PlatformApiProvider is missing.');
    return client;
}
//# sourceMappingURL=platform-api-provider.js.map